var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react": {
		getter: function() { return __webpack_require__.e("vendors-node_modules_react_index_js").then(function() { return function() { return __webpack_require__(/*! react */ "./node_modules/react/index.js"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	"webpack/sharing/consume/default/react-dom/react-dom": {
		getter: function() { return __webpack_require__.e("vendors-node_modules_react-dom_index_js").then(function() { return function() { return __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	"webpack/sharing/consume/default/react-router-dom/react-router-dom": {
		getter: function() { return __webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js").then(function() { return function() { return __webpack_require__(/*! react-router-dom */ "./node_modules/react-router-dom/dist/index.js"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.28.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	"webpack/sharing/consume/default/@amzn/awsui-components-react/@amzn/awsui-components-react": {
		getter: function() { return Promise.all([__webpack_require__.e("vendors-node_modules_amzn_awsui-components-react_polaris_alert_index_js-node_modules_amzn_aws-06537e"), __webpack_require__.e("vendors-node_modules_amzn_awsui-components-react_polaris_index_js"), __webpack_require__.e("data_image_svg_xml_charset_utf-8_3Csvg_xmlns_27http_www_w3_org_2000_svg_27_viewBox_270_0_16_1-f0ec4b1")]).then(function() { return function() { return __webpack_require__(/*! @amzn/awsui-components-react */ "./node_modules/@amzn/awsui-components-react/polaris/index.js"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/awsui-components-react",
	},
	"webpack/sharing/consume/default/@amzn/sdo-privacy-console-sdk/@amzn/sdo-privacy-console-sdk": {
		getter: function() { return __webpack_require__.e("vendors-node_modules_amzn_sdo-privacy-console-sdk_dist_index_js").then(function() { return function() { return __webpack_require__(/*! @amzn/sdo-privacy-console-sdk */ "./node_modules/@amzn/sdo-privacy-console-sdk/dist/index.js"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.1.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/sdo-privacy-console-sdk",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"src_App_Providers_index_ts-src_api_query-utils_index_ts-src_components_ApprovalStatuses_Appro-42885b": [
		"webpack/sharing/consume/default/react-router-dom/react-router-dom",
		"webpack/sharing/consume/default/@amzn/awsui-components-react/@amzn/awsui-components-react"
	],
	"src_components_survey_Kale_tsx-src_components_survey_KaleRoutes_index_ts": [
		"webpack/sharing/consume/default/@amzn/sdo-privacy-console-sdk/@amzn/sdo-privacy-console-sdk"
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}